import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { Client } from "@interfaces/models/client.interface";
import { ClientLocation } from "@interfaces/clientLocation.interface";
import { DeleteObject } from "@interfaces/dto/deleteObject.interface";
import { InvoiceGridRow } from "@interfaces/invoiceGridRow.interface";
import { LogExport } from "@interfaces/logExport.interface";
import { ClientService } from "@services/client.service";
import { ClientLocationService } from "@services/clientLocation.service";
import { ExportLogService } from "@services/exportLog.service";
import { InvoiceService } from "@services/invoice.service";
import { ProtectedGridService } from "@services/protectedGrid.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "invoices-archive",
	styleUrls: ["invoices-archive.css"],
	templateUrl: "invoices-archive.html"
})
export class InvoicesArchiveAdminComponent {
	canExportGrid = false;
	clientLocations: ClientLocation[] = [];
	clients: Client[] = [];
	gridLoading = false;
	headerPrimaryButtons: AdminHeaderButton[] = [{ method: "viewRecent", text: "View Recent" }];
	headerSecondaryButtons: AdminHeaderButton[] = [];
	itemType = "Invoice"
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	items: InvoiceGridRow[] = [];
	popupAddButtonOptions: any = { onClick: () => this.deleteRow(), text: "Delete" };
	popupCloseButtonOptions: any = { onClick: () => this.closePopup(), text: "Close" };
	popupDeleteObject: DeleteObject = new DeleteObject();
	popupTitle = "Generate Detailed Report";
	popupVisible = false;
	title: string;
	
	constructor(private router: Router, private toastService: ToastService, private itemService: InvoiceService, private clientService: ClientService, private clientLocationService: ClientLocationService, private exportLogService: ExportLogService, private protectedGridService: ProtectedGridService) {
		this.title = "Invoice Archive";
		this.deleteRowPopup = this.deleteRowPopup.bind(this);
		this.generatePreviewPDF = this.generatePreviewPDF.bind(this);
		this.viewRecent = this.viewRecent.bind(this);
		this.viewRow = this.viewRow.bind(this);
		this.viewSalesOrder = this.viewSalesOrder.bind(this);
		
		this.getItems();
		this.getClients();
		this.getClientLocations();
		this.checkGridExportPermissions();
	}
	
	checkGridExportPermissions() {
		this.protectedGridService.canExport("Invoice Archive")
			.subscribe(
				(res: any) => {
					this.canExportGrid = res.response;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	closePopup() {
		this.popupVisible = false;
	}

	deleteRow() {
		if (this.popupDeleteObject.reason === "") {
			alert("You must specify a reason for deletion.");
			return;
		}
		this.itemService.delete(this.popupDeleteObject).subscribe(
			() =>{
				this.toastService.success("Successfully Deleted");
				this.closePopup();
				this.getItems();
			},
			(err) => {
				console.log(err);
				this.toastService.error("Something Went Wrong!");
			},
		);
	}
	
	deleteRowPopup(e: any) {
		this.popupTitle = "Delete Invoice";
		this.popupDeleteObject = new DeleteObject();
		this.popupDeleteObject.id = e.row.data.id;
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.deleteRow(), text: "Delete" };
		return false;
	}

	generatePreviewPDF(e: any) {
		this.itemService.generateAndPreviewPdf(e.row.data.id).subscribe(
			(response: any) =>{
				const dataType = response.type;
				const binaryData = [];
				binaryData.push(response);
				const downloadLink = document.createElement("a");
				downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
				downloadLink.setAttribute("download", "INV" + e.row.data.id + "-" + this.clients.find(x => x.id == e.row.data.clientId)?.name +  ".pdf");
				document.body.appendChild(downloadLink);
				downloadLink.click();
			}
		);
	}
	
	getClientLocations() {
		this.clientLocationService.getAll()
			.subscribe(
				(res: any) =>  {
					this.clientLocations = res.response.items;
				},
				(err) => console.log(err)
			);
	}
	
	getClients() {
		this.clientService.getAll()
			.subscribe(
				(res: any) =>  {
					this.clients = res.response.items;
				},
				(err) => console.log(err)
			);
	}

	getItems() {
		this.gridLoading = true;
		this.itemService.getArchived()
			.subscribe(
				(res: any) => {
					this.items = res.response;
					this.gridLoading = false;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	logExport() {
		const logExport = new LogExport();
		logExport.gridName = "Invoice Archive";
		this.exportLogService.logExport(logExport)
			.subscribe(
				() => console.log("Export Logged"),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
					return false;
				},
			);
	}

	viewRecent() {
		this.router.navigate([`${this.itemUrl}`]);
	}

	viewRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.lookupId}`]);
	}

	viewSalesOrder(e: any) {
		this.router.navigate([`admin/salesOrders/${e.row.data.salesOrderLookupId}`]);
	}
}